export default "__VITE_ASSET__DLUplsC1__"